import React from "react";

import { Link } from "react-router-dom";

import { useEffect, useState } from "react";
import { HashLink as HashLink } from 'react-router-hash-link';
import Marquee from "react-fast-marquee";

import Slider from "react-slick";
import './slider.css';
import Image1 from '../assets/image1.png';
import Image2 from '../assets/image2.png';
import Image3 from '../assets/image3.png';
import Image4 from '../assets/image4.png';
import Image5 from '../assets/image5.png';
import Image6 from '../assets/image6.png';
import Image7 from '../assets/image7.png';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';

const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7];

function Home() {
  // States
  const [activeFaq, setActiveFaq] = useState();
  const [value, setValue] = useState(1);
  const NextArrow = ({ onClick }) => {
    return (
      <div className="arrow next" onClick={onClick}>
        <FaArrowRight />
      </div>
    )
  }
  const PrevArrow = ({ onClick }) => {
    return (
      <div className="arrow prev" onClick={onClick}>
        <FaArrowLeft />
      </div>
    )
  }

  const [imageIndex, setImageIndex] = useState(0);
  const settings = {
    infinite: true,
    lazyLoad: true,
    speed: 300,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setImageIndex(next)

  }

  return (
    <React.Fragment>
      {/*------------- Intro Section  ----------------*/}
      <section className="intro" id="intro">
        <div className="container">
          <div className="hero">
            <div className="hero-left">
              <div className="hero-title">
                <img src="./images/hero-title.gif" alt=" Hero Title" />
              </div>
              <p>Allow List Minting - 12:00PM PST
                Public Mint - 3:00PM PST
              </p>
              <div className="hero-btns">
                <HashLink to="mint">
                  <button className="hero-mint-btn">
                    MINT SOON
                    <span class="tooltiptext">Comming Soon</span>
                  </button>
                </HashLink>
                <a href="https://discord.gg/ucPaKkFfUE" target="_blank">
                <button className="hero-join-discord-btn">
                  JOIN DISCORD
                </button>
                </a>
              </div>
            </div>
            <div className="hero-right">
              <div className="hero-img" data-aos="fade-up">
                <img src="./images/hero-right-img.png" alt="Hero Image" />
              </div>
            </div>
          </div>
        </div>

      </section>
      {/* <!---------------------  nft belts -----------------------> */}
      <div className="marqu">
        <div className="belt-title">
          <img src="./images/what-makes-legacyfriends-unique.gif" alt="Belt Tilte" />
        </div>
        <Marquee speed="50" pauseOnHover="true">
          <div className="belt-box">
            {/* Step  */}
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-1.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-2.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-3.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-4.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-5.png" alt="Slider Image" />
              </div>
            </div>
            {/* Step  */}
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-1.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-2.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-3.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-4.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-5.png" alt="Slider Image" />
              </div>
            </div>
            {/* Step  */}
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-1.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-2.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-3.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-4.png" alt="Slider Image" />
              </div>
            </div>
            <div className="box-1">
              <div className="img-1">
                <img src="./images/belt-5.png" alt="Slider Image" />
              </div>
            </div>




          </div>
        </Marquee>
      </div>
      {/*------------- Roadmap Section  ----------------*/}
      <section id="roadmap" className="roadmap">
        <div className="container">
          <div className="roadmap-title">
            <img src="./images/LegacyFriends-Roadmap.gif" alt="Roadmap Title" />
          </div>
          <div className="roadmap-wrapper">
            <div className="roadmap-box">
              <div className="road-box-inner">
                <div className="main-box">
                  <ul>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Website Development
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Social Media Sites Launched
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Public Discord for diverse community engagement
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Private Discord Channels for Members of LegacyFriends
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Pre-mint partnership for Whitelist Raffle for Genesis Series
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Minting LF of Alpha Characters (4 Alpha Characters):
                    </li>
                  </ul>
                  <div className="main-box-bottom">
                    <div>
                      <ul>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Alpha Bull
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Mini
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Badge
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Chef
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Minting of Genesis
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Characters (12)
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Genesis Characters):
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Bull
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Chef
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Matador
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Cat
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Dog
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Veterinarian
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Cadet
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Alien
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          General
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Baker
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Foodie
                        </li>
                        <li>
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6.5" fill="#8ED8F8" stroke="black" />
                          </svg>
                          Shop Owner
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="road-map-img">
                  <img src="./images/roadmap-1-img.png" alt="Roadmap Iamge" />
                </div>
              </div>
              <div className="roadmap-twing">
                <img src="./images/roadmap-twing-1.png" alt="Roadmap Iamge" />
              </div>
            </div>

            <div className="roadmap-box margin-300">
              <div className="road-box-inner">
                <div className="main-box">
                  <ul>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Metatopia staking games begin
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Stake to Earn $Topia token
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      ProjectFriends begins to partner with new NFT Projects for community
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      First FriendsClub Holder’s reward for Holding through July 15th
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Land Plot Sale for Metatopia will begin with LegacyFriends holders whitelisted for Mint
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Additional FriendsClub Rewards to be given based on length of holding
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Metatopia Metaverse Game in the Virtual World with Play 2 Earn $WRLD token
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      Reveal of the 2023 LegacyFriends Takeover Event and Location
                    </li>
                    <li><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="11" cy="11" r="10.5" fill="#8ED8F8" stroke="black" />
                      <path d="M14.2901 6.28694C14.4802 6.10086 14.7332 5.99799 14.9956 6.00003C15.2581 6.00207 15.5095 6.10887 15.6968 6.29788C15.8841 6.4869 15.9927 6.74335 15.9996 7.01312C16.0066 7.28289 15.9113 7.54488 15.734 7.74381L10.3499 14.6674C10.2573 14.7699 10.1456 14.8522 10.0214 14.9093C9.89718 14.9665 9.76304 14.9972 9.62699 14.9998C9.49095 15.0024 9.35579 14.9768 9.22961 14.9244C9.10342 14.8721 8.9888 14.7941 8.89259 14.6952L5.32211 11.0238C5.22268 10.9286 5.14293 10.8137 5.08761 10.686C5.0323 10.5584 5.00256 10.4206 5.00016 10.2809C4.99776 10.1412 5.02276 10.0024 5.07366 9.87278C5.12456 9.74321 5.20032 9.6255 5.29642 9.52669C5.39252 9.42787 5.507 9.34997 5.63301 9.29763C5.75903 9.2453 5.89401 9.21959 6.02989 9.22206C6.16578 9.22452 6.29979 9.25511 6.42394 9.31198C6.54808 9.36886 6.65981 9.45086 6.75246 9.5531L9.57808 12.4571L14.2645 6.31746C14.2729 6.30678 14.2819 6.29659 14.2915 6.28694H14.2901Z" fill="black" />
                    </svg>
                      IRL Meetup’s scheduled for LF in multiple cities
                    </li>
                  </ul>

                </div>
                <div className="road-map-img">
                  <img src="./images/roadmap-2-img.png" alt="Roadmap Iamge" />
                </div>
              </div>
              <div className="roadmap-twing">
                <img src="./images/roadmap-twing-2.png" alt="Roadmap Iamge" />
              </div>
            </div>


          </div>
        </div>
      </section>
      {/*------------- Metatopia Section  -----------*/}
      <section className="metatopia">
        <div className="container">
          <div className="metatopia-title">
            <img src="./images/metatopia.gif" alt="MetaTopia Title" />
          </div>
          <p>We are excited to announce that LegacyFriends will be a part of Season 1 in MetaTopia, the first-ever play-to-earn NFT staking game that utilizes Swap 2.0 technology to establish a more authentic token marketplace</p>
        </div>
        <div className="metatopia-img">
          <img src="./images/metatopia.webp" alt="MetaTopia" />
        </div>
        <div className="container">
          <div className="pye-market">
            <div className="pye">
              <p>PYE Market</p>
            </div>
            <div className="pye">
              <p>MoonFORCE HQ</p>
            </div>
            <div className="pye">
              <p>Bull Street</p>
            </div>
            <div className="pye">
              <p>DOGE World</p>
            </div>
          </div>
        </div>
      </section>
      {/*------------- Tier Section  -----------*/}
      {/* <div className="tier">
        <div className="container">
          <div className="tier-box-all">
            <div className="tier-box">
              <p>Tier 1: Runner, Cat, Cadet, Baker</p>
            </div>
            <div className="tier-box">
              <p>Tier 2: Bull,Do Alien, Foodie</p>
            </div>
            <div className="tier-box">
              <p>Tier 3:
                Matador, Veterinarian, General, Shop Owner</p>
            </div>
          </div>
          <div className="tier-box-all-2">
            <div className="tier-box">
              <p>Tier 4: Alpha Bull, Mini, Badge, Chef</p>
            </div>
          </div>
          <div className="tier-description">
            <p>
              Stay tuned for future Seasons, where new games will be added to the MetaTopia community. ProjectFriends will allow other NFT projects to be added to the game for an ever-expanding universe.
            </p>
          </div>

        </div>

      </div> */}
      {/*------------- Slider Section  -----------*/}
      <section className="slider-manu">
        <div className="container">
          <Slider {...settings}>
            {images.map((img, idx) => (
              <div className={idx === imageIndex ? "slide activeSlide" : "slide"}>
                <img src={img} alt={img} />
              </div>
            ))}
          </Slider>

        </div>

      </section>
      {/*--------------- Team Section  --------------*/}
      <section className="team" id="team">
        <div className="container">
          <div className="team-title">
            <img src="./images/Meet-The-team.gif" alt="Team Title" />

          </div>
          <div className="team-members">
            <div className="member ">
              <div className="member-img member-1">
                <img src="./images/team-1.png" alt="Team Member" />
              </div>
              <h2>BILL SPATA</h2>
              <span>(CEO)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/bill-spata/?original_referer=https%3A%2F%2Fdevteamsix.com%2F" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://twitter.com/BillSpata" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>
            <div className="member">
              <div className="member-img member-2">
                <img src="./images/team-2.png" alt="Team Member" />
              </div>
              <h2>Eric Andersen</h2>
              <span>(CTO)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/defisci/?original_referer=https%3A%2F%2Fdevteamsix.com%2F" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://twitter.com/DeFi_SCI" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>
            <div className="member">
              <div className="member-img member-3">
                <img src="./images/team-3.png" alt="Team Member" />
              </div>
              <h2>Ebony McCray</h2>
              <span>(CMO)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/ebony-mccray/" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://twitter.com/cryptictitan737" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>

          </div>
          <div className="team-members">
            <div className="member">
              <div className="member-img member-4">
                <img src="./images/team-4.png" alt="Team Member" />
              </div>
              <h2>Deven Hammond</h2>
              <span>(CCO)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/deven-hammond/?original_referer=https%3A%2F%2Fwww.legacyfriends.xyz%2F" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://twitter.com/_officialdham" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>
            <div className="member">
              <div className="member-img member-5">
                <img src="./images/team-5.png" alt="Team Member" />
              </div>
              <h2>Christine Turpen</h2>
              <span>(NFT PROJECT MANAGER)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/christine-turpen-70b6b0167/" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://twitter.com/cdturpen" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>
            <div className="member">
              <div className="member-img member-6">
                <img src="./images/team-6.png" alt="Team Member" />
              </div>
              <h2>Gilles Elliot</h2>
              <span>(COMMUNITY DEVELOPMENT)</span>
              <div className="team-social">
                <a href="https://www.linkedin.com/in/gilles-elliott-856a5a19a/?challengeId=AQGQ0ynxT0F-JQAAAYH1SAGaFiciQwIu5hKcofbMMMdDGYc8DCMgH8OeCiYcJE-OkxJ0GCFUOkUkGgEV3bN3TVrYdCWqKJPaMQ&submissionId=556d35e4-f140-0117-a816-2bae663a0025&challengeSource=AgFM0ZTiGwXfbgAAAYH1SFqVWbyVtapoP8G61HEcZTIoOBhx8aN2mnaalliTTFo&challegeType=AgF9GBdoPjqpgwAAAYH1SFqZoLGYTfG8Lb5GC5JJ4qamLnczi2KBNds&memberId=AgEhEg-XXknzRgAAAYH1SFqc4_422Po_x24wSxncACWDSUs&recognizeDevice=AgGWM-Th4lPazwAAAYH1SFqfm2l3nXgI1RRkPV_Z37mdWDKXcYhT" target="_blank">
                  <img src="./images/team-linkedin.png" alt="Linkedin" />
                </a>
                <a href="https://mobile.twitter.com/gdollarsignman" target="_blank">
                  <img src="./images/team-twitter.png" alt="Twitter" />
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/*--------------- Group NFTs Section  --------------*/}
      <section className="group-nft">
        <div className="container">
          <div className="group-all">
            <div className="group">
              <div className="nfts">
                <img src="./images/group-nfts.png" alt="Group NFTs" />
              </div>
            </div>

          </div>
          <div className="price-sector">
            <div className="price-inner">
              <div className="price-box">
                <p>Allow List 0.05 ETH </p>
              </div>
              <div className="price-box">
                <p>Public 0.05 ETH</p>
              </div>
              <div className="price-box">
                <p>Total supply 10,000</p>
              </div>
              <div className="price-box">
                <p>Total Minted 0</p>
              </div>

            </div>

          </div>
        </div>

      </section>
      {/*--------------- community  Section  --------------*/}
      <section className='community' data-aos="fade-up">
        <div className='container'>
          <div className='community-img'>
            <img src="./images/community-img.png" alt="Community Image Not Found" />
            <div className='community-title'>
              <h2><img src="./images/JOIN-OUR-DISCORD-SERVER.gif" alt="Join out Discord Server" /></h2>
            </div>
            <div className='community-btn' data-aos="fade-up">
              <a href='https://discord.gg/ucPaKkFfUE' target='_blank'>
                <img src="./images/community-btn.png" alt="Community Image Not Found" />
              </a>
            </div>
          </div>
        </div>
      </section>


    </React.Fragment>
  );
}

export default Home;
